module.exports = __webpack_public_path__ + "static/media/Holy Cross Newsletter December 2025.3140270d.pdf";